export {CardSolid} from './lib/card-solid';
